import React from 'react';
import { AdminSidebar } from './AdminSidebar';

export const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <AdminSidebar />
      <div className="md:pl-64">
        {children}
      </div>
    </div>
  );
};
